import { render, staticRenderFns } from "./modal_new_award.vue?vue&type=template&id=383eeafa&scoped=true"
import script from "./modal_new_award.vue?vue&type=script&lang=js"
export * from "./modal_new_award.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383eeafa",
  null
  
)

export default component.exports